export default __webpack_public_path__ + "static/media/headquarters.110ef9e9.jpg";